import React from 'react';
import Button from '@material-ui/core/Button';
import Typography from '@material-ui/core/Typography';
import Input from '@material-ui/core/Input';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemSecondaryAction from '@material-ui/core/ListItemSecondaryAction';
import IconButton from '@material-ui/core/IconButton';
import DeleteIcon from '@material-ui/icons/Delete';

import { isValidEmail, isValidDomain } from 'utils/validators';

import { withFormStyles } from '../styles';

class ListForm extends React.Component {
    constructor(props) {
        super(props);
        this.state = this.init();
    }

    init() {
        return {
            values: this.getValues(this.props.policy.value.policy),
            errors: new Set([]),
        };
    }

    componentDidUpdate(prevProps) {
        if (prevProps.policy.value.policy !== this.props.policy.value.policy) {
            this.setState(this.init());
        }
    }

    handleChange = key => event => {
        const { value } = event.target;

        this.setState((state, props) => {
            const newState = Object.assign({}, state.values, {
                [key]: value,
            });
            return { values: newState };
        });
    };

    handleDelete = key => event => {
        this.setState((state, props) => {
            const { [key]: val, ...newState } = state.values;
            return { values: newState };
        });
    };

    handleCancel = event => {
        this.setState(this.init());
    };

    handleAdd = event => {
        this.setState((state, props) => {
            const ids = Object.keys(state.values).map(i => Number(i));
            const nextKey = Math.max(...ids) + 1;
            const newState = Object.assign({}, state.values, {
                [nextKey]: '',
            });
            return { values: newState };
        });
    };

    validateItem = value => {
        if (this.props.policy.policy.identifier === 'POLICY-013') {
            return isValidEmail(value);
        }
        return isValidDomain(value);
    };

    handleSave = event => {
        const errors = Object.entries(this.state.values).reduce(
            (acc, [key, value]) => {
                if (!this.validateItem(value)) {
                    return [key, ...acc];
                }
                return acc;
            },
            []
        );

        this.setState({ errors: new Set(errors) }, () => {
            if (this.state.errors.size === 0) {
                const values = Object.values(this.state.values).join(',');
                const data = {
                    uuid: this.props.policy.uuid,
                    value: values,
                    enabled: values !== '',
                };
                this.props.onSave(data);
            }
        });
    };

    getValues = value => {
        return value.split(',').reduce((acc, val, index) => {
            acc[index] = val;
            return acc;
        }, {});
    };

    getSubTile = policy => {
        const data = {
            'POLICY-004':
                "Items with usernames or login URL's matching these domain will be moved to the team profile in each user's account",

            'POLICY-010':
                'Sharing will be restricted to recipients in these domains',
            'POLICY-013':
                'Recipient(s) in addition to your admin accounts who will receive emails',
        };
        return data[policy.policy.identifier];
    };

    getPlaceholder = policy => {
        const data = {
            'POLICY-004': 'domain.com',
            'POLICY-010': 'domain.com',
            'POLICY-013': 'name@domain.com',
        };
        return data[policy.policy.identifier];
    };

    render() {
        const { classes, policy, enabled, editable } = this.props;
        const placeholder = this.getPlaceholder(policy);
        const disabled = !enabled || !editable;

        return (
            <>
                <div className={classes.formInput}>
                    <Typography>{this.getSubTile(policy)}</Typography>
                    <List dense={true}>
                        {Object.entries(this.state.values).map(
                            ([key, value]) => {
                                return (
                                    <ListItem key={key} disableGutters={true}>
                                        <Input
                                            id={key}
                                            error={this.state.errors.has(key)}
                                            value={value}
                                            placeholder={placeholder}
                                            onChange={this.handleChange(key)}
                                            style={{ paddingRight: '20px' }}
                                            disabled={disabled}
                                        />
                                        <ListItemSecondaryAction>
                                            <IconButton
                                                aria-label="Delete"
                                                onClick={this.handleDelete(key)}
                                                disabled={disabled}
                                            >
                                                <DeleteIcon />
                                            </IconButton>
                                        </ListItemSecondaryAction>
                                    </ListItem>
                                );
                            }
                        )}
                    </List>
                </div>
                <div>
                    <Button
                        size="small"
                        disabled={disabled}
                        variant="contained"
                        className={classes.button}
                        onClick={this.handleCancel}
                    >
                        Cancel
                    </Button>
                    <Button
                        size="small"
                        disabled={disabled}
                        variant="contained"
                        color="secondary"
                        className={classes.button}
                        onClick={this.handleAdd}
                    >
                        Add
                    </Button>
                    <Button
                        size="small"
                        disabled={disabled}
                        variant="contained"
                        color="secondary"
                        className={classes.button}
                        onClick={this.handleSave}
                    >
                        Save
                    </Button>
                </div>
            </>
        );
    }
}

export default withFormStyles(ListForm);
